import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";
import { UserRole } from "@/lib/api/user";
import { AvaChatSidebar } from "@/components/ava/ava-chat-sidebar.tsx";

export const Route = createFileRoute("/_authenticated/ava")({
  component: AvaLayout,
  beforeLoad: ({ context }) => {
    if (
      context?.user?.role !== UserRole.ADMIN &&
      context?.user?.role !== UserRole.SUPERADMIN
    ) {
      throw redirect({
        to: "/",
      });
    }
  },
});

function AvaLayout() {
  return (
    <div className="flex h-screen bg-gray-50">
      <AvaChatSidebar />
      <div className="flex-1">
        <Outlet />
      </div>
    </div>
  );
}
